<template>
  <div class="flex flex-col justify-between w-full">
    <template v-if="$mq === 'sm'">
      <procurement-cell
        :procurement="procurement"
        :key="`procurement_${i}`"
        v-for="(procurement, i) in procurements"
      />
    </template>
    <bdg-table-view :rows="procurements" :columns="columns">
      <template #beside-pagination>
        <bdg-button
          class="ghost has-icon w-full md:w-auto uppercase"
          before-icon-class="fal fa-plus-square"
          @click.native="addProcurement"
        >
          add procurement
        </bdg-button>
      </template>
    </bdg-table-view>
  </div>
</template>

<script>
import BdgButton from "../../elements/BdgButton";
import BdgTableView from "../../elements/table-view/BdgTableView";
import ProcurementCell from "../../elements/list-view/list-view-cells/contract-cells/ProcurementCell";
import IconTextCell from "../../elements/table-view/special-cells/IconTextCell";
import SimpleListCell from "../../elements/table-view/special-cells/SimpleListCell";
import ProcurementForm from "./forms/ProcurementForm";
import GenericDeleteModal from "../../components/modals/GenericDeleteModal";

export default {
  name: "ContractProcurements",
  components: { ProcurementCell, BdgTableView, BdgButton },
  data() {
    return {
      contractId: parseInt(this.$route.params.id, 10),
      columns: [
        { label: "PO#", property: "id" },
        { label: "Vendor", property: "vendorNameWithCompany" },
        {
          label: "Type",
          property: "typeWithIcon",
          cellComponent: IconTextCell
        },
        { label: "Order Date", property: "orderDate" },
        { label: "Delivery Date", property: "deliveryDate" },
        {
          label: "Items",
          property: "nestedItems",
          cellComponent: SimpleListCell
        },
        {
          label: "Actions",
          property: "actions",
          actions: [
            {
              label: "PDF",
              clickAction: workOrder => {
                this.$store.dispatch("getPdfUrl", {
                  type: "procurement",
                  type_id: workOrder.id
                });
              }
            },
            {
              label: "edit",
              clickAction: procurement => {
                this.$store.commit("setCreateEditComponentParams", {
                  createEditComponent: ProcurementForm,
                  createEditComponentData: procurement,
                  createEditComponentIsShown: true
                });
              }
            },
            {
              label: "delete",
              clickAction: procurement => {
                this.$store.commit("setConfirmationModalParams", {
                  type: "delete",
                  headerText: "Delete Confirmation",
                  bodyComponent: GenericDeleteModal,
                  bodyComponentData: {
                    entityName: "procurement",
                    deleteFunction: () =>
                      this.$store.dispatch("deleteProcurement", procurement)
                  },
                  isShown: true
                });
              }
            }
          ],
          additionalCellClasses: "w-px whitespace-no-wrap"
        }
      ]
    };
  },
  computed: {
    procurements() {
      const procurements = this.$store.state.Contracts.Procurements
        .contractProcurements;
      if (procurements) {
        return procurements
          .sort(
            (a, b) =>
              new Date(a.ordered_at).getTime() -
                new Date(b.ordered_at).getTime() || a.id < b.id
          )
          .map(procurement => {
            if (procurement.contact && procurement.contact.subtype) {
              procurement.typeWithIcon = {
                iconClasses: "", // TODO: Get all the icon possibilities from Amanda
                text: procurement.contact.subtype.toUpperCase()
              };
            }

            procurement.nestedItems = {
              items: procurement.items.map(i => i.name)
            };
            return procurement;
          });
      }
      return procurements;
    }
  },
  created() {
    this.$store.dispatch("getContractProcurements", this.contractId);
  },
  methods: {
    addProcurement() {
      this.$store.commit("setCreateEditComponentParams", {
        createEditComponent: ProcurementForm,
        createEditComponentIsShown: true
      });
    }
  }
};
</script>
